<template>
  <div
    v-if="!route.meta.noHeader"
    class="md:h-28 w-full bg-white"
    role="banner"
  >
    <Navbar stage />
    <div
      class="flex flex-col relative items-center justify-center max-w-7xl mx-auto sm:px-6 lg:px-8 z-20 overflow-hidden text-center mt-10"
    ></div>
  </div>
</template>

<script lang="ts" setup>
import { useRoute, useRouter } from "vue-router";
import Navbar from "../Navbar.vue";
const { appContext } = getCurrentInstance()!;
const userAuthenticator = appContext.config.globalProperties.$userAuthenticator;
const route = useRoute();
const router = useRouter();

function logout(): void {
  userAuthenticator.logout();
  router.push({
    name: "slugLogin",
    params: {
      slug: route.params.slug,
    },
  });
}
</script>
